<template>
  <div>
    <v-card
      tile
      elevation="0"
      color="transparent"
      class="d-flex align-center mb-3 px-2"
    >
      <div class="mr-2 text-h6">{{ title }}</div>
      <template v-if="routeName !== 'projectWrite'">
        <v-btn to="/project/write" fab small elevation="0" color="transparent">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <!-- <v-btn fab small elevation="0" color="transparent" @click="showModal">
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
    </v-card>
    <router-view></router-view>
    <!-- <project-list
      :projects="projects"
      @onEditClick="onEditClick"
      @removeProject="removeProject"
    ></project-list>
    <v-dialog v-model="dialog" width="600">
      <project-create
        :isShow="dialog"
        :isModi="isModi"
        :projects="changeProjectData"
        @hideModal="hideModal"
        @createProject="createProject"
      ></project-create>
    </v-dialog> -->
    <!-- <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar> -->
  </div>
</template>

<script>
// import ProjectList from "@/components/project/ProjectList";
// import ProjectCreate from "@/components/project/ProjectCreate";
// import { setPrj, listPrj, modiPrj, delPrj } from "@/api/project";

export default {
  computed: {
    routeName() {
      return this.$route.name;
    },
    title() {
      let title = "프로젝트";
      if (this.routeName === "projectWrite") {
        title = "프로젝트 등록";
      }
      return title;
    },
  },
  data() {
    return {
      // dialog: false,
      // isModi: false,
      // prjNo: null,
      // snackbar: {
      //   show: false,
      //   message: "",
      // },
      // projects: [],
      // changeProjectData: null,
    };
  },
  // components: { ProjectList, ProjectCreate },
  // watch: {
  //   dialog(newVal) {
  //     if (!newVal) {
  //       this.isModi = false;
  //       this.prjNo = null;
  //       this.changeProjectData = null;
  //     }
  //   },
  // },
  // created() {
  //   this.loadList();
  // },
  methods: {
    // showAlert(msg) {
    //   this.snackbar.show = true;
    //   this.snackbar.message = msg;
    // },
    // showModal() {
    //   this.dialog = true;
    // },
    // hideModal() {
    //   this.dialog = false;
    // },
    // onEditClick(item) {
    //   this.isModi = true;
    //   this.changeProjectData = item;
    //   this.prjNo = item.prjNo;
    //   this.showModal();
    // },
    // async loadList() {
    //   try {
    //     const { data } = await listPrj();
    //     const list = data.list.map(v => {
    //       let names = [];
    //       // 참여직원
    //       const empList = v.empList.map(v => {
    //         names.push(v.empNm);
    //         const newList = {
    //           empNo: v.empNo,
    //           empNm: v.empNm,
    //         };
    //         return newList;
    //       });
    //       names = names.join(", ");
    //       // url - 추후 수정
    //       let testUrl = v.testUrlList
    //         ? v.testUrlList.map(i => ({ note: i.note, url: i.url }))
    //         : [];
    //       let realUrl = v.realUrlList
    //         ? v.realUrlList.map(i => ({ note: i.note, url: i.url }))
    //         : [];
    //       const newData = {
    //         ...v,
    //         prjAgncNm: !v.prjAgncNm ? "" : v.prjAgncNm,
    //         prjSt: !v.prjSt ? "" : v.prjSt,
    //         prjStCd: !v.prjStCd ? 200 : v.prjStCd,
    //         empList,
    //         testUrl,
    //         realUrl,
    //         empNms: v.empList.length ? names : "",
    //       };
    //       return newData;
    //     });
    //     this.projects = list;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // async createProject(createData) {
    //   try {
    //     const { data } = !this.isModi
    //       ? await setPrj(createData)
    //       : await modiPrj(this.prjNo, createData);
    //     if (data.ret === 1) {
    //       this.showAlert("저장되었습니다.");
    //       this.loadList();
    //       this.hideModal();
    //     } else {
    //       this.showAlert("저장 실패.");
    //       this.hideModal();
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // async removeProject(item) {
    //   try {
    //     const { prjNo } = item;
    //     const { data } = await delPrj(prjNo);
    //     if (data.ret === 1) {
    //       this.showAlert("삭제되었습니다.");
    //       this.loadList();
    //     } else {
    //       this.showAlert("삭제 실패.");
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>

<style></style>
